























export default {
  ssr: false,
  name: 'Product3DViewer',
  props: {
    src: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      default: '/product3d/poster.jpg',
    },
    environmentImage: {
      type: String,
      default: '/product3d/env.hdr',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
};
